// VersaPay's browser SDK must come from the same VersaPay environment as the server's
// VERSAPAY_BASE_URL, or the card frame loads blank. Set at build time on each Render site:
// production uses https://ecommerce-api.versapay.com/client.js; leave unset for UAT.
export const VERSAPAY_CLIENT_URL =
  process.env.REACT_APP_VERSAPAY_CLIENT_URL || "https://ecommerce-api-uat.versapay.com/client.js";

// The reCAPTCHA checkbox fits in the compact VersaPay frame, but Google's picture challenge
// does not. We can't see inside VersaPay's iframe, so: when focus moves into it (the checkbox
// click), wait briefly. A plain checkbox pass is approved within that time and calls
// stopRecaptchaGrow(); if it's still waiting, Google is showing a challenge, so grow then.
let stopGrow: (() => void) | null = null;

export function stopRecaptchaGrow() {
  stopGrow?.();
  stopGrow = null;
}

export function growFrameWhenRecaptchaClicked(
  iframe: HTMLIFrameElement | null | undefined,
  expandedHeight = "750px",
  waitMs = 5000,
) {
  stopRecaptchaGrow();
  if (!iframe) return;
  let timer: ReturnType<typeof setTimeout> | null = null;
  const onBlur = () => setTimeout(() => {
    if (timer || !iframe.isConnected || document.activeElement !== iframe) return;
    timer = setTimeout(() => {
      if (iframe.isConnected) iframe.style.height = expandedHeight;
      stopRecaptchaGrow();
    }, waitMs);
  }, 0);
  window.addEventListener("blur", onBlur);
  stopGrow = () => {
    window.removeEventListener("blur", onBlur);
    if (timer) clearTimeout(timer);
  };
}
